<template>
    <div class="file-list__item-inner z1">
        <custom-button v-if="picker" @click="$emit('pick', file.id)" class="file-picker__button like-checkbox"
                       v-bind:class="selected ? 'selected' : ''">
            <span class="like-checkbox__checkbox"></span>{{ '\xa0' }}
        </custom-button>

        <a class="file-list__link" :href="file.url">
            <span class="file-list__name">{{ file.title }}</span>
        </a>

        <div class="file-list__item-control" v-if="!picker">
            <button @click="update" iconic><span icon edit></span>Upravit</button>
            <button @click="remove" iconic><span icon remove></span>Odstranit</button>
        </div>
    </div>
</template>

<script>
import FileDialog from './Update/FileDialog';
import CustomButton from '../../../../components/Button/CustomButton';
import {defaultModalParameters} from '../../../../system/modal/modal.params';

export default {
    name:       'FileMediaItem',
    components: {CustomButton},
    props:      {
        file:     {
            type:     Object,
            required: true,
        },
        selected: {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        picker:   {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
    },
    computed:   {
        files() {
            return this.$store.getters['media/files'];
        }
    },
    methods:    {
        update() {
            this.$modal.show(FileDialog, {
                file: this.file,
            }, defaultModalParameters({name: 'file-form'}))
        },
        remove() {
            const {id, title} = this.file;
            this.$modal.show('dialog', {
                text:    'Opravdu chcete soubor <strong>' + title + '</strong> odstranit?',
                buttons: [
                    {
                        title:   'Zrušit',
                        handler: () => this.$modal.hide('dialog')
                    }, {
                        title:   'Odstranit',
                        handler: () => {
                            this.$store.dispatch('removeFile', id)
                                .catch((message) => this.$dmv.notifyError(message));
                            this.$modal.hide('dialog');
                        }
                    },
                ]
            });
        }
    }
}
</script>


